

//----------------video-slider-----------------//

var swiper = new Swiper('.video-box-slider', {
  slidesPerView: 'auto',
  centeredSlides: false,
  paginationClickable: true,
  loop: true,
  a11y: false,
  shortSwipes: true,
  navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  breakpoints: {
    749: {
      loop: true,
       slidesPerView: 'auto',
      centeredSlides: false,
    }
  }
});


var recommended_swiper = new Swiper('.recommended-products__content', {
  navigation: {
      nextEl: '.carousel__navigation-buttons [data-next]',
      prevEl: '.carousel__navigation-buttons [data-prev]',
    },
});
// var recent_swiper = new Swiper('.recently-viewed-products__content', {
//   navigation: {
//       nextEl: '.carousel__navigation-buttons [data-next]',
//       prevEl: '.carousel__navigation-buttons [data-prev]',
//     },
// });


//----------------You may like this slider on cart-----------------//

var swiper = new Swiper('.cross-sells__items[data-cross-sells-slider-cart]', {
  slidesPerView: 1.5,
  spaceBetween:12,
  navigation: {
    nextEl: '.slider-nav-button-next',
    prevEl: '.slider-nav-button-prev',
  },
  breakpoints: {
    749: {
       slidesPerView: 4
    }
  }
});



// -----------------video----------------//

document.addEventListener('DOMContentLoaded', function () {
  const videoImages = document.querySelectorAll('.video-box-slider .video-image');

  videoImages.forEach(videoImage => {
    const video = videoImage.querySelector('video');

    if (video) {
      videoImage.addEventListener('click', function () {
        if (video.paused) {
          video.play();
          videoImage.classList.add('playing');
        } else {
          video.pause();
          videoImage.classList.remove('playing');
        }
      });
    }
  });
});

// -------------- Read More Read Less Functionality on Collection Banner ---------------- //
document.addEventListener('DOMContentLoaded', function(){
  const Collection_descriptions = document.querySelectorAll('.coll_desc');
  if(Collection_descriptions.length > 0){
    Collection_descriptions.forEach(coll_desc=>{
      const ReadMoreButton = coll_desc.querySelector('.ReadMore_button');
      if(ReadMoreButton){
        ReadMoreButton.addEventListener('click', ()=>{
          if(ReadMoreButton.classList.contains('read_more_active')){        
            coll_desc.querySelector('.main_desc').style.display = "none";
            coll_desc.querySelector('.short_desc').style.display = "block";
            ReadMoreButton.innerText = 'Read More';
            ReadMoreButton.classList.remove('read_more_active');        
          } else {
            coll_desc.querySelector('.main_desc').style.display = "block";
            coll_desc.querySelector('.short_desc').style.display = "none";
            ReadMoreButton.innerText = 'Read Less';
            ReadMoreButton.classList.add('read_more_active');
          }
        })
      }
    })
  }
});



// ------------------ Custom Menu Drawer Close Icon --------------------- //
document.addEventListener('DOMContentLoaded', function () {
  const MenuDrawer = document.querySelector('.drawer-menu');
  if(MenuDrawer){
    const custom_close_icon = MenuDrawer.querySelector('.custom-close-button');
    if(custom_close_icon){
      custom_close_icon.addEventListener('click',()=>{
        const header_mobile = document.querySelector('.header__row-mobile');
        if(header_mobile){
          const MainCloseIcon = header_mobile.querySelector('.header__menu-icon');
          if(MainCloseIcon){
            setTimeout(()=>{MainCloseIcon.click()},100);
          }
        }
      })
    }
  }
});

// ___________________ Option_Selector ___________________
// document.addEventListener('DOMContentLoaded', function () {
//   const customDropdownOptions = document.querySelectorAll('.Option_Selector');
//   if(customDropdownOptions.length > 0){
//     customDropdownOptions.forEach(container=>{
//       if(container){
//         const optionLabel = container.querySelector('.selector_inner');
//         if(optionLabel){
//           optionLabel.addEventListener('click', ()=>{
//             optionLabel.classList.toggle('option-area-open');
//           })
//         }
//         if(container.querySelector('ul')){
//           const OptionSelector = container.querySelector('ul')
//           if(OptionSelector){
//             const OptionId = container.querySelector('ul').getAttribute('id');            
//             if(OptionSelector && OptionId){          
//               const hiddenSelectTag = document.querySelector(`#${OptionId}`);
//             }
//             OptionSelector.addEventListener('change', ()=>{
//               console.log(OptionSelector);
//             })
//           }
//         }
//       }
//     })
//   }
// });

// -----------------Responsive menu dropdown----------------//

document.addEventListener('DOMContentLoaded', function () {
  var nav = document.querySelector('.size-guide-nav');
  if(nav){    
    var ul = nav.querySelector('ul');
    var lis = ul.querySelectorAll('li');
    var activeLi = nav.querySelector('li.active');
    var dropdownSelected = document.createElement('div');
    dropdownSelected.className = 'dropdown-selected';
    dropdownSelected.innerHTML = '<span>' + activeLi.querySelector('a').textContent + '</span>';
    nav.insertBefore(dropdownSelected, ul);
    
    function toggleDropdown() {
      if (window.innerWidth <= 767) {
        ul.style.display = 'none';
        dropdownSelected.style.display = 'block';
        dropdownSelected.addEventListener('click', function() {
          ul.style.display = ul.style.display === 'none'? 'block' : 'none';
          if (ul.style.display === 'block') {
            dropdownSelected.classList.add('active');
          } else {
            dropdownSelected.classList.remove('active');
          }
        });
      } else {
        ul.style.display = 'block';
        dropdownSelected.style.display = 'none';
        dropdownSelected.classList.remove('active');
      }
    }
    
    toggleDropdown();
    
    window.addEventListener('resize', toggleDropdown);
  }
});

// -----------------Onclick scroll to section----------------//

document.addEventListener('DOMContentLoaded', function() {

    function getHeaderHeight() {
        var header = document.querySelector('header.header');
        if (header) {
            return header.offsetHeight;
        }
        return 0;
    }

    var height = getHeaderHeight();

    window.addEventListener('resize', function() {
        height = getHeaderHeight();
    });

    var links = document.querySelectorAll('a[href^="#"]');

    links.forEach(function(link) {
        link.addEventListener('click', function(e) {
            e.preventDefault();

            var targetId = this.getAttribute('href').substr(1);
            var targetElement = document.getElementById(targetId);

            if (targetElement) {
                var offsetTop = targetElement.offsetTop - height;
                window.scrollTo({
                    top: offsetTop,
                    behavior: 'smooth'
                });
            }
        });
    });
});





let index = 1;

const on = (listener, query, fn) => {
	document.querySelectorAll(query).forEach(item => {
		item.addEventListener(listener, el => {
			fn(el);
		})
	})
}

on('click', '.selectBtn', item => {
	const next = item.target.nextElementSibling;
	next.classList.toggle('toggle');
	next.style.zIndex = index++;
});
on('click', '.option', item => {
	item.target.parentElement.classList.remove('toggle');

	const parent = item.target.closest('.select').children[0];
	parent.setAttribute('data-type', item.target.getAttribute('data-type'));
	parent.innerText = item.target.innerText;
})



//split_payments__readmore
var split_payments = document.querySelector('.split_payments__readmore');
if(split_payments){
  split_payments.addEventListener('click', function(e) {
    console.log("clicked");
    document.querySelector('body').classList.toggle('toggleClass');
  });
}
